import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Divider, ListItemIcon, ListItemText } from "@mui/material";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";

const BasicMenu = ({
  anchorEl,
  handleClose,
  open,
  menuItems,
  totalNotification,
  size,
  page,
  sendDataToChild,
  menuShowData,
  length,
}) => {
  if (menuShowData.length === 0) {
    menuShowData = menuItems;
    length = totalNotification;
  } else {
    menuShowData = [...menuShowData, menuItems];
  }

  const sizeCounter = () => {
    sendDataToChild();
  };

  if (menuShowData.length > 0) {
    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {menuShowData.map((item) => (
          <MenuItem onClick={handleClose} key={item.id}>
            {item.isRead === false ? <b>{item.message}</b> : item.message}
          </MenuItem>
        ))}
        <Divider />
        {length > size ? (
          <MenuItem onClick={sizeCounter}>
            <ListItemIcon>
              <AddCircleRoundedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>More Notification</ListItemText>
          </MenuItem>
        ) : null}
      </Menu>
    );
  }
};

export default BasicMenu;
